<template>
    <div class="main" v-loading="loading" :element-loading-text="loadingText">
    <el-card class="box-card"  style="padding:0  !important;   width: 1000px">
      <el-row>
      <el-col style=" background-color:#1df;" :span="12" >
        <div style="display: flex;justify-content:center;align-items: center;height:500px;  width: 100%" >
          <div>
            <div style="text-align: center;"><el-image :src="logo"  :fit="'fit'" style="height:80px;"></el-image></div> 
            <div style="text-align: center;line-height: 40px; font-size: 30px;" >
              天津大学浙江研究院
            </div>
            <div style="text-align: center;line-height: 40px; font-size: 30px;">
              实验室安全教育培训与管理系统
            </div>
          </div>
        </div>       
      </el-col>
      <el-col :span="12">
      <main class="aui-page__login">
        <div class="login-header">
          <h2 class="login-brand">登录</h2>
        </div>
        <div class="login-body">
          <!-- <h3 class="login-title">{{ login.title }}</h3> -->
          <el-form :model="dataForm"  status-icon>
          <el-form-item label="选择登录方式:">
            <el-radio-group v-model="dataForm.radio"  @input="changeStatus(dataForm.radio)">
              <el-radio :label="'3'">用户名密码</el-radio>
              <!-- <el-radio :label="'6'">短息认证码</el-radio> -->
            </el-radio-group>
          </el-form-item>
            <el-form-item prop="username">
              <el-input
                :placeholder="dataForm.placeholderOne"
                v-model="dataForm.username">
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item v-if="!dataForm.vertifyCodeFlag">
              <el-input
                :placeholder="dataForm.placeholderTwo"
                v-model="dataForm.password" show-password>
                <i slot="prefix" class="el-input__icon el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item v-else>
              <el-row :gutter="20">
                <el-col :span="10">
                  <el-input v-model="dataForm.vertifyCode" :placeholder="dataForm.placeholderThree">
                    <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                  </el-input>
                </el-col>
                <el-col :span="7">
                  <el-button type="primary"  :disabled="timer.tagTimerFlag" @click="sendVertifyCode()" >获取验证码</el-button>
                </el-col>
                <el-col :span="7">
                  <el-tag type="primary" v-if ="timer.tagTimerFlag" >{{timer.seconds}}秒后重新获取</el-tag>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="doLogin()" >登录</el-button>
              <el-button type="danger" @click="cancelSubmit()">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="login-footer">
          <!-- <p>
            <a href="http://demo.open.renren.io/renren-security" target="_blank">12132</a>
          </p>
          <p><a href="https://www.renren.io/" target="_blank">12312321</a>2022 © renren.io</p> -->
        </div>
      </main>
      </el-col>
    </el-row>
    </el-card>
  </div>
</template>
<script>
import logo from "@/assets/image/yuanhui.png"
import {stringIsNullOrEmpty} from  '@/api/utils'
import {MESSAGE_DURATION} from  '@/api/constant'
import { TOKEN_ID } from '@/mutation/mutConst'
import axios from  '@/api/axiosConfig'
export default {
  name : 'pc_ctr_login',
  data () {
    return {
      logo,
      captchaPath: '',
      dataForm: {
        placeholderOne :"请输入用户名",
        placeholderTwo :"请输入密码",
        placeholderThree :"请输入验证码",
        username: '',
        password: '',
        vertifyCode :'',
        radio : "3",
        vertifyCodeFlag : false
      },
      timer:{
        timerId :'',
        seconds:'',
        multiSendTtl:'',
        tagTimerFlag : false
      },
      login:{
        demo: "123123",
        lg :"whaah",
        title :"请输入",
        copyright : "无版权"
      },
      loading: false,
      loadingText:''
    }
  },
  methods: {
    cancelSubmit(){
      this.dataForm.username = ""
      this.dataForm.password = ""
      this.dataForm.vertifyCode = ""
    },
    changeStatus(val){
      if(val == 3){
        this.dataForm.vertifyCodeFlag = false
        this.dataForm.placeholderOne = "请输入用户名"
      }else{
        this.dataForm.vertifyCodeFlag = true
        this.dataForm.placeholderOne = "请输入手机号码"
      }
    },

    timerFunc(){
      console.log(this.timer.seconds)
      const startTime = new Date()
      if(this.timer.seconds === ''){
        const timeTtl = (startTime.getTime()  + 1 * 1000 * 60 )
        this.timer.multiSendTtl = timeTtl
        this.timer.seconds = 60
        this.timer.tagTimerFlag = true
        return 
      }
      console.log(1)
      if(this.timer.seconds === 0){
        this.timer.seconds  = ''
        this.timer.multiSendTtl = ''
        this.timer.tagTimerFlag = false
        setTimeout(()=>{
          if(this.timer.timerId != '' ){
            clearInterval(this.timer.timerId)   
            this.timer.timerId = '' 
          }
        },200)
        return 
      }
      console.log(2)
      if( startTime.getTime() > this.timer.multiSendTtl){
        this.timer.seconds = 0;
        return 
      }
      console.log(3)
      let seconds  = this.timer.seconds  - 1
      if(seconds <= 0 ){
        this.timer.seconds == 0;
      }else{
        this.timer.seconds = seconds
      }
      
    },

    doLogin(){


      let dat = {};
      let url = "";
      try{
        if(this.dataForm.radio == 3){
          stringIsNullOrEmpty(this.dataForm.username, "用户名不能为空")
          stringIsNullOrEmpty(this.dataForm.password, "密码不能为空")
          url = "/bc/exa/usr/login"
          dat.usrName = this.dataForm.username,
          dat.password = this.dataForm.password
        } else{
          stringIsNullOrEmpty(this.dataForm.username, "用户名不能为空")
          stringIsNullOrEmpty(this.dataForm.vertifyCode, "验证码不能为空")
          url = "/bc/exa/usr/loginByPhoneCode"
          dat.phoneNo = this.dataForm.username,
          dat.phoneCode = this.dataForm.vertifyCode
        }
      }catch(e){
        this.$message({
          showClose: true,
          message:e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return 
      }

      this.loading = true
      this.loadingText = '请求中...'
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        this.loading = false
        if (response.data.code === 0){
          console.log(response.data)
          this.$store.commit(TOKEN_ID, response.data.data.token)
          this.$router.push({path:'/pc_index'})
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) => {
        this.loading = false
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    sendVertifyCode(){
      let url = "/bc/exa/usr/sendPhoneCode"
      let dat = {
        phoneNo : this.dataForm.username
      }
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.timer.timerId = setInterval(this.timerFunc,1000)
            this.$message({
              showClose: true,
              message: '发送成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch((err) => {
          this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
          }) 
      })
    },
    cancelSubmit(){
       this.dataForm.username=""
       this.dataForm.password=""
       this.dataForm.vertifyCode=""
    },
  },
  beforeRouteLeave(to, from, next){
    
    if (this.timer.timerId != '') {
      clearInterval(this.timer.timerId);
      this.timer.timerId = '';
    }
    this.cancelSubmit();
    next();
  },
  beforeDestroy(){
    if (this.timer.timerId != '') {
      console.log("销毁定时器")
      clearInterval(this.timer.timerId);
      this.timer.timerId = '';
    }
  }
  
}
</script>

<style lang="less" scoped>
.main {
  display: flex;
  justify-content:center;
  align-items: center;
  height: 100%; 
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%; 
  background-image: url('../assets/image/xueyuan.png');
}
/deep/.el-card__body {

  padding: 0px;
}


.aui-page__login {
  &::before,
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    content: "";
  }
  &::before {
    
    background-size: cover;
  }
  &::after {
    background-color: rgba(38, 50, 56, .4);
  }
  .aui-content {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 50px 20px 150px;
    text-align: center;
    aui-content__wrapper {
      height: 100vh;
      background-color: transparent;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  .login-header {
    padding: 20px;
    color: #111;
    .login-brand {
      margin: 15px auto;
      padding:0 auto;
      font-size: 30px;
      font-weight: 400;
      letter-spacing: 2px;
      text-align: center;
    }
    .login-intro {
      padding: 0;
      margin: 0;
      list-style: none;
      > li {
        font-size: 16px;
        line-height: 1.5;
        color: rgba(255, 255, 255, .6);
        & + li {
          margin-top: 5px;
        }
      }
    }
  }
  .login-body,
  .login-footer {
    width: 460px;
  }
  .login-body {
    padding: 20px 30px;
    background-color: #fff;
    .login-title {
      font-size: 18px;
      font-weight: 400;
    }
    .el-input__prefix .el-input__icon {
      font-size: 16px;
    }
    .login-captcha {
      height: 10px;
      line-height: 10px -2px;
      > img {
        max-width: 100%;
        cursor: pointer;
      }
    }
    .login-shortcut {
      margin-bottom: 20px;
      &__title {
        position: relative;
        margin: 0 0 15px;
        font-weight: 400;
        
        &::before {
          position: absolute;
          top: 50%;
          right: 0;
          left: 0;
          z-index: 1;
          content: "";
          height: 1px;
          margin-top: -.5px;
          background-color: #F32;
          overflow: hidden;
        }
        > span {
          position: relative;
          z-index: 2;
          padding: 0 20px;
          color: rgba(0, 0, 0, .3);
          background-color: #fff;
        }
      }
      &__list {
        padding: 0;
        margin: 0;
        list-style: none;
        font-size: 0;
        > li {
          display: inline-block;
          vertical-align: middle;
          margin: 0 10px;
          font-size: 28px;
        }
      }
    }
    .login-guide {
      color: rgba(0, 0, 0, .3);
    }
  }
  .login-footer {
    width: 460px;
    position: absolute;
    bottom: 0;
    padding: 20px;
    color: rgba(255, 255, 255, .6);
    p {
      margin: 10px 0;
    }
    a {
      padding: 0 5px;
      color: rgba(255, 255, 255, .6);
      &:focus,
      &:hover {
        color: #fff;
      }
    }
  }
  // 右侧垂直风格
  &--right-vertical {
    .aui-content {
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: stretch;
      padding: 0;
    }
    .login-header {
      flex: 1;
      display: flex;
      flex-flow: column wrap;
      justify-content: center;
      padding: 30px 120px;
      text-align: left;
    }
    .login-body {
      position: relative;
      display: flex;
      flex-flow: column wrap;
      justify-content: center;
      padding: 120px 30px 150px;
      text-align: center;
      .login-guide {
        margin-top: 0;
      }
    }
    .login-footer {
      right: 0;
      color: #F32;
      a {
        color: #F32;
        &:focus,
        &:hover {
          color: #F32;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .aui-page__login {
    &--right-vertical {
      .login-header {
        padding: 30px;
      }
    }
  }
}
@media (max-width: 767px) {
  .aui-page__login {
    &--right-vertical {
      .login-header {
        .login-brand,
        .login-intro {
          display: none;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .aui-page__login {
    .login-body,
    .login-footer {
      width: 100%;
    }
    .login-captcha {
      text-align: left;
      > img {
        width: 136px;
      }
    }
    &--right-vertical {
      .login-header {
        display: none;
      }
    }
  }
}

</style>






// WEBPACK FOOTER //
// src/pc_pages/login.vue